<p-autoComplete
  #autocomplete
  [disabled]="disabled"
  [inputId]="id"
  [suggestions]="filteredList"
  (completeMethod)="filterBrands($event)"
  [class.validation-error]="validationError"
  [placeholder]="placeHolderValue || fieldValidationObject?.placeholder"
  [pattern]="pattern || fieldValidationObject?.allowedChars"
  [maxlength]="maxlength || fieldValidationObject?.fieldAttributes?.max"
  [minlength]="minlength || fieldValidationObject?.fieldAttributes?.min"
  [autoHighlight]="autoHighlight"
  [(ngModel)]="value"
  (onKeyUp)="onSelectChange()"
  (onSelect)="onSelection()"
  (blur)="onBlur()"
  (onFocus)="onFocus()"
  (click)="onFocus()"
  tmoAllowedInput
>
</p-autoComplete>
<p *ngIf="isInputDirty" class="small error-label">{{ validationErrorText }}</p>
